<template>
  <b-form-group
    label="Ürün"
    label-for="id_categories"
  >
    <v-select
      id="id_products"
      v-model="dataItem.id_products"
      label="title"
      :options="products"
      :reduce="product => product.id"
      placeholder="Seçiniz"
      :disabled="!products.length"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ProductsNotificationsCard',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['notifications/dataItem']
    },
    products() {
      return this.$store.getters['products/dataList']
    },
  },
}
</script>
